<template>
  <b-modal :id="modalId"
           title="Delete Webhook">
    <p>Are you sure you want to delete this webhook?</p>
    <template slot="modal-footer">
      <button type="button" class="btn btn-secondary" @click="hideModal">Cancel</button>
      <button type="button" class="mr-0 btn btn-danger"
              @click="promiseClearWebhook = handleClear()"
              v-busy-button="promiseClearWebhook">Delete
      </button>
    </template>
  </b-modal>
</template>

<script>
  import notificationService from '@/services/notification/notification.service'
  import channelService from '@/services/amio-api/channel.service'

  export default {
    props: {
      modalId: {
        type: String,
        required: true
      },
      channel: {
        type: Object,
        required: true
      }
    },

    data() {
      return {
        promiseClearWebhook: null
      }
    },

    methods: {
      hideModal() {
        this.promiseClearWebhook = null
        this.$root.$emit('bv::hide::modal', this.modalId)
      },

      handleClear() {
        const patch = {
          webhook: null
        }
        return channelService
          .patch(this.channel.id, patch)
          .then(() => {
            this.$emit('webhookCleared')
            notificationService.success('Webhook was successfully deleted')
          })
          .then(this.hideModal)
      }
    }
  }
</script>
